import api from '@/api';

const resource = 'ei/atividadeavaliativa';

export default {
  deleteAtividadeAvaliativa(data) {
    return api.delete(`${resource}/${data.id}`);
  },
  postAtividadeAvaliativa(data) {
    return api.post(`${resource}`, data);
  },
  putAtividadeAvaliativa(data) {
    return api.put(`${resource}/${data.identificadoratividade}`, data);
  },
  getAtividadeAvaliativa(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
};
